import { Account, AccountType, AccountWithIndex, CheckingAccount, AccountItem } from '@algoan/dashboard/model';

export const filterCheckingAndSavingsAccounts = (accounts?: Account[]): CheckingAccount[] =>
  (accounts?.filter((account) => [AccountType.CHECKING, AccountType.SAVINGS].indexOf(account.type) > -1) ??
    []) as CheckingAccount[];

export const filterOutLoanAccounts = <T extends Account | AccountWithIndex | AccountItem>(accounts: T[]): T[] =>
  accounts.filter((account) => [AccountType.LOAN, AccountType.UNKNOWN].indexOf(account.type) === -1);

export const filterLoanAccounts = <T extends Account | AccountWithIndex>(accounts: T[]): T[] =>
  accounts.filter((account) => account.type === AccountType.LOAN);

export const filterOutComputedAccounts = <T extends Account | AccountWithIndex>(accounts: T[]): T[] =>
  accounts.filter((account) => account.isComputed === false);

export const filterOutIgnoredAccounts = <T extends Account | AccountWithIndex>(accounts: T[]): T[] =>
  accounts.filter((account) => account.isComputed !== false);
